export const keyOfForm = ['code', 'name', 'note', 'companyId', 'companyName'];
export default (data) => {
  return keyOfForm.map((item) => {
    return {
      name: [item],
      value: data[item] || null,
      errors: [],
    };
  });
};
